module.exports = __webpack_public_path__ + "fonts/f8bce4f.otf";